<template>
  <a-locale-provider :locale="zh_CN">
    <div id="app">

      <vheader></vheader>


      <div id="main">
        <div class="slider" v-if="$store.getters.ttoken || $store.getters.token">
          <selectStudent></selectStudent>
        </div>
        <router-view id="content" />
        <div id="back-btn" v-if="!$route.query.isEditingNewStudent">
          <Button type="primary" @click="back">
            <Icon type="ios-arrow-back"></Icon>
            返回
          </Button>
        </div>
      </div>


      <div id="footer">
        备案号：
        <a class="beian" target="_blank" href="https://beian.miit.gov.cn/"><img class="beian-logo"
            :src="beianPng" />辽ICP备2021009506号</a>
      </div>

    </div>
  </a-locale-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import vheader from '@/components/header.vue';
import selectStudent from '@/components/select-student.vue';
import beianPng from "@/assets/imgs/beian.png";

moment.locale('zh-cn');

export default {
  components: {
    vheader,
    selectStudent
  },
  data() {
    return {
      zh_CN,
      beianPng
    }
  },
  methods: {
    back() {
      this.$router.back();
    }
  }
}
</script>
<style lang="less">
@import url(//at.alicdn.com/t/font_2660389_5gshiye1cyp.css);


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}

html,
body,
#app {
  height: 100%;
}


#main {
  flex: 1;
  display: flex;
  overflow: hidden;

  .slider {
    width: 240px;
    height: 100%;
    border-right: 1px solid #dcdee2;
    overflow-y: auto;
    overflow-x: hidden;
  }

  #content {
    padding: 30px;
    flex: 1;
    height: 100%;
    overflow-y: scroll;
  }

  #back-btn {
    position: absolute;
    left: 240px;
    bottom: 100px;
  }

  .fixed-right-bottom {
    position: absolute;
    right: 10px;
    bottom: 100px;
    z-index: 99;
  }
}

#footer {
  height: 60px;
  border-top: 1px solid #dcdee2;

  display: flex;
  align-items: center;
  justify-content: center;

  .beian {
    display: inline-flex;
    align-items: center;
    margin-left: 10px;
    color: #333;
    text-decoration: none;

    .beian-logo {
      width: 16px;
      height: auto;
      display: inline-block;
      margin-right: 5px;
    }
  }
}
</style>
